/**!
 * Swiper 11.2.2
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2024 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: April 9, 2024
 */

// sp_search.js
// 　フィルタ機能
// TODO: ✅ 商品の並び順のルール：`item_badge`の`New`がある商品は並び順の最上位にする。もし、複数の商品に`New`がある場合は商品リストの`id`と組み合わせて、並びを変える。
// TODO: 商品画像が検索条件を変えるたびに再取得してしまう。画像の取得は一度だけにする。
// TODO: 🔺 不要なループ処理があるので、調査・改善する。
// TODO: 🔺 キーワード検索toggleのフォーカスが開く前から、当たってしまうので、当たらないように修正する。
// TODO: ✅ 絞り込み付きのボタン（URLパラメータを付与して立ち上げる）の場合は、一度既存のパラメータを削除してから、新しいパラメータを付与する。
// TODO: ✅ チェックボックスグループで（見た目上、）親子関係がある場合、親がチェックされたら、隠れていた子要素も表示する。一度表示したら、チェックボックスの状態に関わらず、表示したままにする。ex.「ヒールレンジ」の「ヒールの高さ」、ウィズの「幅レンジ」、「幅（E）」など。
// TODO: ✅ URLパラメータが3重エンコードになっているので、適切なエンコードに変更する。アンパサンド（&）が原因か？
// TODO: ✅ URLパラメータでチェックボックスにチェックが入っている状態にし、絞り込みをする。URLパラメータを取得し、チェックボックスの初期状態を設定します。URLパラメータが変更されたときにチェックボックスの状態も更新します。
// TODO: ✅ [item_wpの洗える]と[うれしい機能の洗える]のチェックが同期されてしまう。また、[うれしい機能]に「洗える」が表示され、結果として、[うれしい機能]に2つ「洗える」が表示されてしまう。
// TODO: ✅ ブラウザバックをすると、パラメータの変化をhistroyとして、残してしまうので、検索のパラメータに関しては、ブラウザバックの対象外にする。
// TODO: ✅ jsonデータで`&（アンパサンド）`がついている「通常ヒール&フラット、ウエッジ&スニーカーソール、かかとジェルクッション&ジェル、きれい&かわいい」のように&（アンパサンド）があるものがチェックボックスの絞り込みができない。
// TODO: ✅ ヒールレンジとヒールの高さを同じ、`sf-controls-checkbox`に設置したい。
// TODO: ✅ `extractBooleanFilterOptions`のソートを設定。
// TODO: ✅ カウント数がおかしいのがある。原因を調査中。
// TODO: ✅ 要素の表示：trueの場合は表示する。
// TODO: ✅ swiper.jsで表示する画像が8枚ぴったりの枚数とは限らないので、動的に処理する必要がある。→ シートに画像点数を記入することで解決。
// TODO: ✅ チェックボックスの一部をAND検索にする
// TODO: ✅ `sf-result__remove`のところ、「OFFでもOK」、「スポーティ」が削除できないので、修正する。
// TODO: ✅ 順序の定義を設定したチェックボックスのソートが機能していない。

// モーダル
// TODO: 検索モーダルのフォーカスロックが効いていないので、修正する。
// TODO: ItemModalモーダルを立ち上げて、閉じた後に立ち上げる前の要素にフォーカスが移るので、画面が少し動く。→ モーダルを閉じた後に、スクロール位置を固定する。
// TODO: ✅ トランジション（表示／非表示のアニメーション）にならない
// TODO: ✅ ID管理だと、複数のモーダルを開いたときにIDが重複するので、管理方法をdata属性（もしくはクラスなど）に変更する。
// TODO: ✅ キーワード検索のモーダルを立ち上げるボタンのdata属性を使用して、チェックボックスの初期状態を設定する。
// TODO: ✅ ItemModalモーダル表示時のtabindexがおかしいので、修正する。
// WARNING: 8photoモーダルのスライダーは画像の点数以外にファイル名をとびとびの可能性があるので、現状は都度リネームをかける必要がある。
// TODO: micromoda.jsを使用しないモーダルに変更する。

// カード
// TODO: 掲載内容が不規則の画像altタグを自動生成する。

// GA4
// TODO: ✅ 絞り込み状況をGA4に送信する。（1. チェックボックスの操作ごとにトラッキング + 2. 検索モーダルを閉じたら、まとめて送信トラッキング）

import { createRoot } from "react-dom/client";
import SearchModal from "./components/SearchModal/SearchModal";
import ItemCardSingleModal from "./components/ItemCardSingleModal/index";
import ItemCardCategoryList from "./components/ItemCardCategoryList";
import ItemFilterList from "./components/ItemFilterList";

// Initialize the modal
ItemCardSingleModal();

// Object to store the root references
const roots = {};

const rootElements = [
 {
  id: "search_filters",
  component: <SearchModal />,
 },
 {
  id: "item_cards_basic_basic_pumps",
  component: <ItemCardCategoryList categoryId="ベーシックパンプス" />,
 },
 {
  id: "item_cards_active_memory_foam_insoles_sneaker_pumps",
  component: <ItemCardCategoryList categoryId="形状記憶 スニーカーパンプス" />,
 },
 {
  id: "item_cards_active_inheel_sneaker_pumps",
  component: <ItemCardCategoryList categoryId="インヒール スニーカーパンプス" />,
 },
 {
  id: "item_cards_active_wedge_pumps",
  component: <ItemCardCategoryList categoryId="ウェッジパンプス" />,
 },
 {
  id: "item_cards_active_flexible_moccasin_shoes",
  component: <ItemCardCategoryList categoryId="しなやかモカシンシューズ" />,
 },
 {
  id: "item_cards_active_soft_loafers",
  component: <ItemCardCategoryList categoryId="ソフトローファー" />,
 },
 {
  id: "item_cards_active_boots",
  component: <ItemCardCategoryList categoryId="ブーツ" />,
 },
 {
  id: "item_cards_relax_knit_pumps",
  component: <ItemCardCategoryList categoryId="ニットパンプス" />,
 },
 {
  id: "item_cards_smart_bit_loafers",
  component: <ItemCardCategoryList categoryId="ビットローファー" />,
 },
 {
  id: "item_cards_smart_ballet_pumps",
  component: <ItemCardCategoryList categoryId="バレエパンプス" />,
 },
 {
  id: "item_cards_sports_wedge_sneakers",
  component: <ItemCardCategoryList categoryId="ウェッジスニーカー" />,
 },
 {
  //シリーズIDでの絞り込み
  id: "item_cards_smart",
  component: <ItemCardCategoryList seriesId="スマート" />,
 },
 //  {
 //   id: "filtered_items_root",
 //   component: <ItemFilterList rootId="filtered_items_root" width="4E" toe="スクエアトゥ" heelHeight="5.0cm" />,
 //  },
 //  {
 //   id: "filtered_items_feature_job_hunting",
 //   component: <ItemFilterList rootId="filtered_items_feature_job_hunting" category="ベーシックパンプス" width="3E-5E" toe="スクエアトゥ" heelHeight="2.5cm-5.0cm" itemMaterial="合成皮革" />,
 //  },
 {
  //サブカテゴリIDでの絞り込み
  id: "item_cards_feature_job_hunting",
  component: <ItemCardCategoryList subcategoryId="就活&フレッシャーズ" />,
 },
 {
  id: "filtered_items_width_2E",
  component: <ItemFilterList rootId="filtered_items_width_2E" width="2E" />,
 },
 {
  id: "filtered_items_width_3E",
  component: <ItemFilterList rootId="filtered_items_width_3E" width="3E" />,
 },
 {
  id: "filtered_items_width_4E",
  component: <ItemFilterList rootId="filtered_items_width_4E" width="4E" />,
 },
 {
  id: "filtered_items_width_5E",
  component: <ItemFilterList rootId="filtered_items_width_5E" width="5E" />,
 },
 {
  id: "filtered_items_toe_round",
  component: <ItemFilterList rootId="filtered_items_toe_round" toe="ラウンドトゥ" />,
 },
 {
  id: "filtered_items_toe_square",
  component: <ItemFilterList rootId="filtered_items_toe_square" toe="スクエアトゥ" />,
 },
 {
  id: "filtered_items_toe_almond",
  component: <ItemFilterList rootId="filtered_items_toe_almond" toe="アーモンドトゥ" />,
 },
 {
  id: "filtered_items_toe_pointed",
  component: <ItemFilterList rootId="filtered_items_toe_pointed" toe="ポインテッドトゥ" />,
 },
 {
  id: "filtered_items_heel_1_0cm",
  component: <ItemFilterList rootId="filtered_items_heel_1_0cm" heelHeight="1.0cm" />,
 },
 {
  id: "filtered_items_heel_2_0cm",
  component: <ItemFilterList rootId="filtered_items_heel_2_0cm" heelHeight="2.0cm" />,
 },
 {
  id: "filtered_items_heel_2_3cm",
  component: <ItemFilterList rootId="filtered_items_heel_2_3cm" heelHeight="2.3cm" />,
 },
 {
  id: "filtered_items_heel_2_5cm",
  component: <ItemFilterList rootId="filtered_items_heel_2_5cm" heelHeight="2.5cm" />,
 },
 {
  id: "filtered_items_heel_3_0cm",
  component: <ItemFilterList rootId="filtered_items_heel_3_0cm" heelHeight="3.0cm" />,
 },
 {
  id: "filtered_items_heel_3_5cm",
  component: <ItemFilterList rootId="filtered_items_heel_3_5cm" heelHeight="3.5cm" />,
 },
 {
  id: "filtered_items_heel_4_0cm",
  component: <ItemFilterList rootId="filtered_items_heel_4_0cm" heelHeight="4.0cm" />,
 },
 {
  id: "filtered_items_heel_5_0cm",
  component: <ItemFilterList rootId="filtered_items_heel_5_0cm" heelHeight="5.0cm" />,
 },
 {
  id: "filtered_items_heel_6_0cm",
  component: <ItemFilterList rootId="filtered_items_heel_6_0cm" heelHeight="6.0cm" />,
 },
 {
  id: "filtered_items_heel_6_5cm",
  component: <ItemFilterList rootId="filtered_items_heel_6_5cm" heelHeight="6.5cm" />,
 },
 {
  id: "filtered_items_heel_7_0cm",
  component: <ItemFilterList rootId="filtered_items_heel_7_0cm" heelHeight="7.0cm" />,
 },
];

rootElements.forEach(({ id, component }) => {
 const container = document.getElementById(id);
 if (container) {
  if (!roots[id]) {
   // Create a root if it doesn't exist
   roots[id] = createRoot(container);
   //    console.log(`Root created for container ID: ${id}`);
  }
  // Render the component using the existing root
  roots[id].render(component);
  //   console.log(`Component rendered for container ID: ${id}`);
 } else {
  //   console.warn(`Container with ID "${id}" not found`);
 }
});
